var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClassroomsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.04,
    y: 8.04,
    width: 11.12,
    height: 7.92,
    rx: 1.8,
    stroke: "#1E1E1E",
    strokeOpacity: 0.8,
    strokeWidth: 1.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.92 12.72L13.72 10.92L15.16 12.18L17.32 10.2",
    stroke: "#1E1E1E",
    strokeOpacity: 0.8,
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 15.96L11.52 19.56M16.6 15.96L17.68 19.56M14.6 15.96V18.12",
    stroke: "#1E1E1E",
    strokeOpacity: 0.8,
    strokeWidth: 1.08,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroomsIcon);
export default __webpack_public_path__ + "static/media/Classrooms-icon.edcfb166d7d328831d64bf115411d500.svg";
export { ForwardRef as ReactComponent };